import {FlatList, Platform, Text, View} from 'react-native';
import React from 'react';
import {useTheme} from 'contexts/ThemeContext';
import styleSheet from './styles';

export interface CustomXAxisProps {
  tickValueArray: number[];
  lineContainerStyle?: object;
  tickContainerStyle?: object;
  scaleStyle?: object;
  textStyle?: object;
}

const CustomXAxis = (props: CustomXAxisProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  return (
    <View style={[styles.defaultLineContainerStyle, props.lineContainerStyle]}>
      <FlatList
        horizontal
        showsHorizontalScrollIndicator={false}
        scrollEnabled={false}
        data={props.tickValueArray}
        renderItem={({item}) => {
          return (
            <View
              style={[
                styles.defaultTickContainerStyle(
                  item,
                  Platform.OS === 'web' ? 20 : 29,
                ),
                props.tickContainerStyle,
              ]}
              key={item}>
              <View style={[styles.defaultScaleStyle, props.scaleStyle]} />
              <Text style={[styles.defaultTextStyle, props.textStyle]}>
                {item === 0 ? null : item}
              </Text>
            </View>
          );
        }}
      />
    </View>
  );
};

export default CustomXAxis;
